export const setAuthValue = (value: string, key: any) => ({
  type: 'SET_AUTH_VALUE',
  payload: { [value]: key },
});
